export const changePassword = {
    "change_pwd_title": "change the password",
    "change_pwd_old_password": "Current Password",
    "change_pwd_new_password": "New Password",
    "change_pwd_confirm_password": "Confirm password",
    "change_pwd_error": "Error changing password"
}